<!--创建订单-->
<template>
    <div id="creatOrder">
        <Breadcrumb></Breadcrumb>
        <div class="co-body">
<!--            <div class="co-head"><span>创建订单</span></div>-->
<!--            <div class="co-btn">-->
<!--                <el-button size="small" type="primary">导入手工订单</el-button>-->
<!--                <el-button size="small" type="warning">引用现有订单</el-button>-->
<!--            </div>-->
            <el-form :model="form" ref="form" :rules="rules" label-position="right">
                <div class="co-form-tit"><span class="tit-sp">订单信息</span></div>
                <div class="co-form-con">
                    <el-form-item label="订单号:" prop="sAppNo" class="wit-40">
                        <el-input size="small" v-model="form.sAppNo"></el-input>
                    </el-form-item>
                    <el-form-item label="Email:" class="wit-40" prop="mail">
                        <el-input size="small" placeholder="非必填项，买家E-Mail" v-model="form.mail"></el-input>
                    </el-form-item>
                </div>
                <div class="co-form-tit"><span class="tit-sp">收货地址</span></div>
                <div class="co-form-con">
                    <div class="addr-row">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="收件人:" prop="cons">
                                    <el-input size="small" v-model="form.cons"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="电话:" prop="tel">
                                    <el-input size="small" v-model="form.tel"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="手机:" prop="mobile">
                                    <el-input size="small" v-model="form.mobile"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="公司:" label-width="100" prop="company">
                                    <el-input size="small" v-model="form.company"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="税号:" label-width="100" prop="taxNo">
                                    <el-input size="small" v-model="form.taxNo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="国家/地区:" prop="country">
                                    <el-select   filterable v-model="form.country" size="small" class="country-select" placeholder="支持中、英文搜索">
                                        <el-option :label="item.label" :value="item.value" v-for="item in countries"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="省/州:" prop="province">
                                    <el-input size="small" v-model="form.province"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="城市:" prop="city">
                                    <el-input size="small" v-model="form.city"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="地址1:" label-width="100" prop="addr1">
                                    <el-input size="small" v-model="form.addr1"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="门牌号:" label-width="100" prop="houNum">
                                    <el-input size="small" v-model="form.houNum"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="地址2:" label-width="100" prop="addr2">
                                    <el-input size="small" v-model="form.addr2"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="邮编:" label-width="100" prop="post">
                                    <el-input size="small" v-model="form.post"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="co-form-tit"><span class="tit-sp">商品信息</span>
                </div>
                <div style="width: 100%;text-align: right">
                    <el-button size="mini" type="primary" style="float: right;margin-right: 20px;margin-top: 1px" @click="addGoods">增加商品</el-button>
                </div>
                <div class="co-form-con">
                    <div class="tab-dynamic">
                        <el-row class="head-row">
                            <el-col :span="7"><span style="color: red">*</span>商品SKU</el-col>
                            <el-col :span="5">属性</el-col>
                            <el-col :span="5"><span style="color: red">*</span>数量</el-col>
                            <el-col :span="5" style="display: flex;justify-content: center"><span style="color: red">*</span>单价
                                <el-select clearable  v-model="form.coinType" size="mini" style="width: 100px">
                                    <el-option :value="item" :label="item" v-for="item in rateObj"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="2">操作</el-col>
                        </el-row>
                        <el-row class="dynamic-row" v-for="(item,index) in form.orderSkuList" :key="index">
                            <el-col :span="7" style="display: flex;height: 34px">
                                <el-form-item class="pro-info-sku" :prop="`orderSkuList[${index}].skuName`" :rules="rules.skuName" :inline-message="inLineMessage">
                                    <el-input size="small" v-model="item.skuName"></el-input>
<!--                                    <el-button type="primary" plain size="mini" class="info-sku-bt">指定SKU</el-button>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item class="pro-info-sku" :prop="`orderSkuList[${index}].skuAttr`">
                                    <el-input size="small" placeholder="非必填项" v-model="item.skuAttr"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item class="pro-info-num" :prop="`orderSkuList[${index}].num`" :rules="rules.num" :inline-message="inLineMessage">
                                    <el-input-number size="small" v-model="item.num" :step="1" step-strictly :min="0" :controls="showControls"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item class="pro-info-num" :prop="`orderSkuList[${index}].price`" :rules="rules.price" :inline-message="inLineMessage">
                                    <el-input-number size="small" v-model="item.price" :precision="2" :step="0.1" :min="0.00" :controls="showControls"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-button type="text" size="small" @click="deleteRow(item)">删除 </el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="co-form-tit"><span class="tit-sp">订单备注</span></div>
                <div class="co-form-con">
                    <div class="description">
                        <el-form-item prop="remark">
                            <el-input type="textarea" v-model="form.remark" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="co-form-con bot-con">
                    <div class="bottom-div">
                        <span>订单总金额： </span><span style="color: red;font-size: 16px">{{form.coinType}} {{totalAmount}}</span>
                        <el-form-item label="运费(￥)" prop="fare">
<!--                            <el-input size="small" v-model="form.fare"></el-input>-->
                            <!--<span style="color: red;font-size: 16px">{{form.coinType}} {{totalAmount}}</span>-->
                            <el-input-number v-model="form.fare" :precision="2" :step="0.1" :min="0" size="small" :controls="showControls"></el-input-number>
                        </el-form-item>
                    </div>
                    <div style="float: right">
                        <el-button type="primary" size="small" @click="submitForm">创建</el-button>
                        <el-button size="small">取消</el-button>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {saveOrder} from '@/api/order/all'
    import {showValidateMsg} from '@/utils/jn'
    export default {
        name: "creatOrder",
        components:{Breadcrumb},
        data(){
            return{
                inLineMessage:true,
                notShow:false,
                showControls:false,
                form:{
                    sAppNo:null,//订单号
                    mail:null,//邮箱
                    cons:null,//收件人
                    tel:null,//电话
                    mobile:null,//手机
                    company:null,//公司
                    taxNo:null,//税号
                    country:null,//国家
                    province:null,//省、州
                    city:null,//城市
                    addr1:null,//地址1
                    addr2:null,//地址2
                    houNum:null,//门牌号
                    post:null,//邮编
                    coinType:'USD',
                    sOrderStatus:'4',//手工创建订单初始状态为 待处理
                    orderSkuList:[
                        {
                            skuName:null,
                            skuAttr:null,
                            num:0,
                            price:0
                        }],
                    remark:null,//备注
                    proPri:0,
                    fare:0,//运费
                },
                rules:{
                    sAppNo:[{required: true, message: '订单号不能为空', trigger: 'blur'},{min: 5, max: 20, message: '订单号长度在 5 到 20 个字符', trigger: 'blur'}],
                    cons:[{required: true, message: '收件人不能为空', trigger: 'blur'}],
                    country:[{required: true, message: '国家/区域不能为空', trigger: 'change'}],
                    province:[{required: true, message: '省/州不能为空', trigger: 'blur'}],
                    city:[{required: true, message: '城市不能为空', trigger: 'blur'}],
                    addr1:[{required: true, message: '地址1不能为空', trigger: 'blur'}],
                    skuName:[{required: true, message: 'sku不能为空', trigger: 'blur'}],
                    num:[{required: true, message: '数量不能为空', trigger: 'blur'}],
                    price:[{required: true, message: '单价不能为空', trigger: 'blur'}],
                },
                countries:[],
                rateObj:['AED',	'AFN',	'ALL',	'AMD',	'AOA',	'ARS',	'AUD',	'AWG',	'AZN',	'BAM',	'BBD',	'BDT',	'BGN',	'BHD',	'BIF',	'BMD',	'BND',	'BOB',	'BRL',	'BSD',	'BTN',	'BWP',	'BYR',	'BZD',	'CAD',	'CDF',	'CHF',	'CLP',	'CNY',	'COP',	'CRC',	'CUP',	'CVE',	'CZK',	'DEM',	'DJF',	'DKK',	'DOP',	'DZD',	'EGP',	'ERN',	'ETB',	'EUR',	'FJD',	'FKP',	'FRF',	'GBP',	'GEL',	'GIP',	'GMD',	'GNF',	'GTQ',	'GYD',	'HKD',	'HNL',	'HRK',	'HTG',	'HUF',	'IDR',	'IEP',	'ILS',	'INR',	'IQD',	'IRR',	'ISK',	'ITL',	'JMD',	'JOD',	'JPY',	'KES',	'KGS',	'KHR',	'KMF',	'KPW',	'KRW',	'KWD',	'KYD',	'KZT',	'LAK',	'LBP',	'LKR',	'LRD',	'LSL',	'LTL',	'LVL',	'LYD',	'MAD',	'MDL',	'MGA',	'MKD',	'MMK',	'MNT',	'MOP',	'MRO',	'MUR',	'MVR',	'MWK',	'MXN',	'MYR',	'MZN',	'NAD',	'NGN',	'NIO',	'NOK',	'NPR',	'NZD',	'OMR',	'PAB',	'PEN',	'PGK',	'PHP',	'PKR',	'PLN',	'PYG',	'QAR',	'RON',	'RSD',	'RUB',	'RWF',	'SAR',	'SBD',	'SCR',	'SDG',	'SEK',	'SGD',	'SHP',	'SLL',	'SOS',	'SRD',	'STD',	'SVC',	'SYP',	'SZL',	'THB',	'TJS',	'TMT',	'TND',	'TOP',	'TRY',	'TTD',	'TWD',	'TZS',	'UAH',	'UGX',	'USD',	'UYU',	'UZS',	'VEF',	'VND',	'VUV',	'WST',	'XAF',	'XCD',	'XOF',	'XPF',	'YER',	'ZAR',	'ZMW'],
            }
        },
        computed:{
            totalAmount(){
                let amount = 0;
                this.form.orderSkuList.forEach(item =>{
                    amount += item.num * item.price;
                })
                return amount.toFixed(2);
            }
        },
        created(){
            let that = this;
            this.countries = [];
            $.ajax({
                url:process.env.BASE_URL + 'country.json',
                method:'get',
                success:function (res) {
                    let all = [];
                    for(let key in res.map){
                        all = all.concat(res.map[key])
                    }
                    all.filter(item =>{
                        that.countries.push({
                            label:item.countryCh + ' ' + item.countryEn,
                            // value:item.smtCode
                            value:item.countryCh
                        })
                    })

                }
            })
        },
        methods:{
            addGoods:function(){
                this.form.orderSkuList.push({skuName:null, skuAttr:null, num:null, price:null})
            },
            deleteRow:function (val) {
                let index = this.form.orderSkuList.indexOf(val);
                if(index !== -1){
                    this.form.orderSkuList.splice(index,1);
                }
            },
            submitForm(){
                let that = this;
                this.form.proPri = this.totalAmount;
                this.$refs['form'].validate((valid,msgArr) =>{
                    if(valid){
                        saveOrder(this.form).then(res =>{
                            if(res.code == 200){
                                that.msgSuccess('创建成功');
                            }
                        }).catch(err =>{})
                    }else{
                        let arr = [];
                        for(let item in msgArr){
                            msgArr[item].forEach(obj =>{
                                if(arr.indexOf(obj.message)<0){
                                    arr.push(obj.message);
                                }
                            })
                        }
                        this.$message.error({
                            dangerouslyUseHTMLString: true,
                            showClose: true,
                            message: '<span>'+arr.join('，')+'</span>'
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>
    #creatOrder{width: 100%;height: 100%}

</style>
